
import createAPIServices from './createAPIServices'

const api = createAPIServices()

// list report
export const getListReportsUserCanView = (user_id = 0, page_number = 1, page_size = 10, status = 'Existed', text = "", begin_time = null, end_time = null) => {
    let query = `/multitierflow/user/${user_id}?page_number=${page_number}&page_size=${page_size}&status=${status}`

    if (text !== null && text !== '')
        query = query + `&text=${text}`

    if (begin_time !== null && end_time !== null)
        query = query + `&begin_time=${begin_time}&end_time=${end_time}`

    return api.makeAuthRequest({
        url: query,
        method: 'GET'
    })
}

export const getListReportsByTier = (tier_id = 1, page_number = 1, page_size = 10, status = 'Existed', text= null, begin_time = null, end_time = null) => {
    let query = `/multitierflow/tier/${tier_id}?page_number=${page_number}&page_size=${page_size}&status=${status}`
    
    if (text !== null && text !== '')
        query = query + `&text=${text}`

    if (begin_time !== null && end_time !== null)
        query = query + `&begin_time=${begin_time}&end_time=${end_time}`

    return api.makeAuthRequest({
        url: query,
        method: 'GET'
    })
}

// history report 
export const getListUserReport = (uid = 0, page_number = 1, page_size = 10, status = 'Existed', text = "", begin_time = null, end_time = null) => {
    console.log("Hala")
    let query = `/multitierflow/user/${uid}/created?page_number=${page_number}&page_size=${page_size}&status=${status}`

    if (text !== '')    
        query = query + `&text=${text}`

    if (begin_time !== null && end_time !== null)
        query = query + `&begin_time=${begin_time}&end_time=${end_time}`

    return api.makeAuthRequest({
        url: query,
        method: 'GET'
    })
}

// curent report 
export const createReport = (tier_id = 0, report = {}) => {
    const json = JSON.stringify(report)

    return api.makeAuthRequest({
        url: `/multitierflow?tier_id=${tier_id}`,
        method: 'POST',
        data: json,
        header: {
            'Content_Type': 'application/json'
        }
    })
}

export const updateReport = (fid = 0 , report = {}) => {
    const json = JSON.stringify(report)

    return api.makeAuthRequest({
        url: `/multitierflow/${fid}`,
        method: 'PUT',
        data: json,
        header: {
            'Content-Type': 'application/json'
        }
    })
}

export const deleteReport = (fid = 0) => {
    return api.makeAuthRequest({
        url: `/multitierflow/${fid}`,
        method: 'DELETE'
    })
}

export const getReportById = (fid = 0) => {
    return api.makeAuthRequest({
        url: `/multitierflow/${fid}`,
        method: 'GET'
    })
}

export const sendReport = (fid = 0) => {
    return api.makeAuthRequest({
        url: `/multitierflow/${fid}/send`,
        method: 'POST'
    })
}

export const updateReportStatus = (fid = 0, status = '') => {
    return api.makeAuthRequest({
        url: `/multitierflow?fid=${fid}&status=${status}`,
        method: 'PUT'
    })
} 

export const updateReadedReport = (fid = 0) => {
    return api.makeAuthRequest({
        url: `/multitierflow/read/${fid}`,
        method: 'PUT'
    })
}

// comments 
export const getCommentsInReport = (fid = 0) => {
    return api.makeAuthRequest({
        url: `/multitierflow/${fid}/comments`,
        method: 'GET'
    })
} 

export const createCommentInReport = (report_id, comment) => {
    comment = {
        ...{
            content: comment.content,
            report_id: report_id
        },
    }

    let json = JSON.stringify(comment)

    return api.makeAuthRequest({
        url: `/multitierflow/comment`,
        method: 'POST',
        data: json,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export const updateCommentInReport = (cid = 0, comment) => {
    let json = JSON.stringify(comment)
    return api.makeAuthRequest({
        url: `/multitierflow/comment/${cid}`,
        method: 'PUT',
        data: json,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export const deleteCommentInReport = (cid = 0) => {
    return api.makeAuthRequest({
        url: `/multitierflow/comment/${cid}`,
        method: 'DELETE'
    })
}

// select media 
export const getListMediasByArray = (ids = []) => {
    return api.makeAuthRequest({
        url: `/media/query/list?ids=${ids}`,
        method: 'GET'
    })
}

// select object 
export const getListObjectsByArray = (ids = []) => {
    return api.makeAuthRequest({
        url: `/object/query/list?ids=${ids}`,
        method: 'GET'
    })
}

// select event 
export const getListEventsByArray = (ids = []) => {
    return api.makeAuthRequest({
        url: `/event/query/list?ids=${ids}`,
        method: 'GET'
    })
}

// select report 
export const getListRelatedsByFid = (fid = 0) => {
    return api.makeAuthRequest({
        url: `/multitierflow/${fid}/related`,
        method: 'GET'
    })
}

